import request from '../utils/request';

export function getGrilledMaterials(params, signal) {
  return request({
    url: '/dictionaries/grilled-materials',
    method: 'get',
    data: params,
    signal,
  });
}

export function createGrilledMaterial(params) {
  return request({
    url: '/dictionaries/grilled-materials',
    method: 'post',
    data: params,
  });
}

export function updateGrilledMaterial(uuid, params) {
  return request({
    url: `/dictionaries/grilled-materials/${uuid}`,
    method: 'put',
    data: params,
  });
}

export function deleteGrilledMaterial(uuid) {
  return request({
    url: `/dictionaries/grilled-materials/${uuid}`,
    method: 'delete',
    data: uuid,
  });
}

export function getGrilledFilterMaterials() {
  return request({
    url: '/dictionaries/grilled-materials/all',
    method: 'get',
  });
}
